<div fxFlex fxLayout="column" class="mat-typography">
  <div class="dialog-header" fxLayoutAlign="start center">
    <h3 fxFlex="100" mat-dialog-title>{{ title }}</h3>
    <button
      mat-icon-button
      fxFlex="none"
      fxFlexAlign="end"
      (click)="dialogRef.close()"
    >
      <mat-icon class="mat-24" [attr.aria-label]="closeLabel">clear</mat-icon>
    </button>
  </div>
  <div class="dialog-body" fxLayout="column wrap" fxLayoutAlign="center center">
    <p [innerHTML]="confirmMessage"></p>
    <br />
    <p [innerHTML]="typeToConfirm"></p>

    <div fxFlex="25">
      <mat-form-field>
        <input
          matInput
          [(ngModel)]="userInput"
          value="userInput"
          name="name"
          type="text"
          [placeholder]="inputPlaceholder"
          required
        />
      </mat-form-field>
    </div>
  </div>
  <div class="dialog-footer" fxLayout="row" fxLayoutAlign="end center">
    <button mat-button (click)="dialogRef.close()">{{ cancelLabel }}</button>
    <button
      mat-raised-button
      class="delete-button"
      [disabled]="!isValid()"
      (click)="dialogRef.close(data)"
    >
      {{ deleteLabel }}
    </button>
  </div>
</div>
